/**
 * AR Vision Demo — demo-only workflow route (scenes 5 + 9).
 *
 * THROWAWAY DEMO CODE. Registers `/demo/ar/workflow` so the scene-5/9 tools can
 * navigate to the demo workflow canvas. Wired into the route tree from
 * `frontend/src/routes.tsx` (one import + one tree entry). No permission or
 * module gating — it only renders fixture state and is gated by demo mode in
 * practice. Delete alongside frontend/src/demo/ar.
 */

import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '@/pages/authenticated/route';
import paths from '@/paths';
import { DemoWorkflowPage } from './DemoWorkflowPage';

export const Route = createRoute({
  path: paths.authenticated.demoArWorkflow,
  getParentRoute: () => pathlessAuthenticatedRoute,
  component: DemoWorkflowPage,
  loader: () => ({ crumb: 'AR Demo Workflow' }),
});
